import { Exclude, Expose } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';
import { IsBoolean, IsString } from 'class-validator';
import { UserRoleRegionListInterface } from '../interfaces/user-role-region-list.interface';

@Exclude()
export class UserRoleRegionListDto implements UserRoleRegionListInterface {
  @ApiProperty({
    type: 'string',
    title: 'id',
  })
  @Expose()
  @IsString()
  id!: string;

  @ApiProperty({
    type: 'string',
    title: 'firstName',
  })
  @Expose()
  @IsString()
  firstName!: string;

  @ApiProperty({
    type: 'string',
    title: 'lastName',
  })
  @Expose()
  @IsString()
  lastName!: string;

  @ApiProperty({
    type: 'string',
    title: 'fullName',
  })
  @Expose()
  @IsString()
  fullName!: string;

  @ApiProperty({
    type: 'boolean',
    title: 'active',
  })
  @Expose()
  @IsBoolean()
  active!: boolean;

  @ApiProperty({
    type: 'string',
    title: 'regionIds',
  })
  @Expose()
  @IsString()
  regionIds!: string;

  @ApiProperty({
    type: 'string',
    title: 'roleNames',
  })
  @Expose()
  @IsString()
  roleNames!: string;
}
